import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";
import { getCurrentUser } from "@/network/queries/get-current-user";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import type { TWpCurrentUser } from "@/network/typings";
import { getServerLogger } from "@/utils/logger";

const DEV_ADMIN = import.meta.env.PUBLIC_DEV_ADMIN_BAR === "true";

export const checkWpAuth = createServerFn({ method: "GET" })
  .middleware([loggingMiddleware])
  .handler(async (): Promise<TWpCurrentUser | null> => {
    if (DEV_ADMIN) return { name: "Dev", id: 1, email: "dev@localhost" };

    const headers = getRequestHeaders();
    const cookie = headers.get("cookie") ?? "";

    try {
      return await getCurrentUser(cookie);
    } catch (e) {
      getServerLogger().error({ err: String(e) }, "wp-auth: checkWpAuth error");
      return null;
    }
  });
